import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import type { IpValidationResults } from '@packages/utils/validate-ip-addresses/validate-ip-addresses';

export const useUploadMessage = (results?: IpValidationResults) => {
  const { t } = useTranslation('telemetryScannerConfig', {
    keyPrefix: 'scannerConfiguration',
  });

  return useMemo(() => {
    if (!results) return '';
    const { valid, duplicate, invalid } = results;
    const message = [];

    if (valid.size) message.push(t('validEntries', { n: valid.size }));

    if (Object.keys(duplicate).length) {
      const duplicateCount = Object.values(duplicate).reduce(
        (acc, curr) => acc + curr.size,
        0,
      );

      message.push(t('duplicateEntries', { n: duplicateCount }));
    }

    if (invalid.size) message.push(t('invalidEntries', { n: invalid.size }));

    return message.join(' ');
  }, [results, t]);
};
